import { EstadoServidorDtSource } from "../../bussines/dataSources/EstadoServidorDtSource";
import { EstadoServidorRepository } from "../../bussines/repositories/EstadoServidorRepository";
import { EstadoServidorModel } from "../models/EstadoServidorModel";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevValidacion } from 'lib.common/dist/errorHandler';

export class EstadoServidorRepositoryImpl implements EstadoServidorRepository<EstadoServidorModel> {
   private dataSource: EstadoServidorDtSource;

   constructor(dataSource: EstadoServidorDtSource) {
      this.dataSource = dataSource;
   }

   async getEstadoServidores(): Promise<Recurso<EstadoServidorModel[]>> {
      try {
         const result = await this.dataSource.getEstadoServidores();

         if (result.isSuccess()) {
            return Recurso.fromData<EstadoServidorModel[]>(
               result.data!.map(EstadoServidorModel.deserialize)
            );
         }
         return Recurso.fromError<EstadoServidorModel[]>(result.error!);
      } catch (error) {
         return Recurso.fromError<EstadoServidorModel[]>(
            new ErrDevValidacion(error as Error)
         );
      }
   }
}